
import { Project } from '../models/project';
import { Task } from '../models/task';

export class TimecardRow {
    project: Project = new Project();
    task: Task = new Task();

    mon: string = '0';
    tue: string = '0';
    wed: string = '0';
    thu: string = '0';
    fri: string = '0';
    sat: string = '0';
    sun: string = '0';
    
    monId: number = 0;
    tueId: number = 0;
    wedId: number = 0;
    thuId: number = 0;
    friId: number = 0;
    satId: number = 0;
    sunId: number = 0;

    tasksLoading = false;

    message: string = '';
    invalidProj: boolean = false
    invalidTask: boolean = false;

    static fromJSONArray(timecardRows: Array<any>): TimecardRow[] {
        return timecardRows.map(row => new TimecardRow(row));
    }

    constructor(timecardRow?: any) {
        if (!!timecardRow) {
            this.project = new Project(timecardRow['project'])
            this.task = new Task(timecardRow['task'])
            this.mon = timecardRow['mon'];
            this.tue = timecardRow['tue'];
            this.wed = timecardRow['wed'];
            this.thu = timecardRow['thu'];
            this.fri = timecardRow['fri'];
            this.sat = timecardRow['sat'];
            this.sun = timecardRow['sun'];
            this.invalidProj =  timecardRow['invalidProj'];
            this.invalidTask = timecardRow['invalidTask'];
            this.message = timecardRow['message'];
        }
    }

    setHoursOnDay(date: any, hours: number, timeId: number) {
        let realDate = new Date(date);

        switch (realDate.getDay()) {
            case 0:
                this.sun = hours.toString();
                this.sunId = timeId;
                break;
            case 1:
                this.mon = hours.toString();
                this.monId = timeId;
                break;
            case 2:
                this.tue = hours.toString();
                this.tueId = timeId;
                break;
            case 3:
                this.wed = hours.toString();
                this.wedId = timeId;
                break;
            case 4:
                this.thu = hours.toString();
                this.thuId = timeId;
                break;
            case 5:
                this.fri = hours.toString();
                this.friId = timeId;
                break;
            case 6:
                this.sat = hours.toString();
                this.satId = timeId;
                break;
        }
    }

    // private _total: number = 0;
    get total(): number {
        return Number(this.mon) +
            Number(this.tue) +
            Number(this.wed) +
            Number(this.thu) +
            Number(this.fri) +
            Number(this.sat) +
            Number(this.sun);
    }


}
